module.exports = __webpack_public_path__ + "media/images/zoom-7da48407b81572b40fa6259f1f129d43.gif";